module.exports = __webpack_public_path__ + "img/00018.c061700f.webp";